
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^webpack_sharing_consume_default_(o(rpc_(client_orpc_client|tanstack\-query_orpc_tanstack\-query\-webpack_sharing_consu\-8fddaa)|idc\-client\-ts_oidc\-client\-ts)|react\-(((dom_react|router\-dom_react\-router)\-do|hook\-form_react\-hook\-for)m|oidc\-context_react\-oidc\-context)|(capacitor_core_capacitor_co|dagrejs_dagre_dagrejs_dag)re|clsx_clsx\-webpack_sharing_consume_default_tailwind\-merge_tail\-23ec03|dnd\-kit_utilities_dnd\-kit_utilities|xyflow_react_xyflow_react)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
